import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';

export type MobileNavContextType = {
  mobileNavOpen: boolean;
  setMobileNavOpen: (open: boolean) => void;
  isMobile: boolean;
};

export const MobileNavContext = createContext<MobileNavContextType>(null as never);

export const useMobileNav = (): MobileNavContextType => {
  const context = useContext(MobileNavContext);
  if (!context) {
    throw new Error('useMobileNav must be used within a MobileNavProvider');
  }
  return context;
};

export const MobileNavProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  return (
    <MobileNavContext.Provider value={{ mobileNavOpen, setMobileNavOpen, isMobile }}>
      {children}
    </MobileNavContext.Provider>
  );
};
